module.exports = __webpack_public_path__ + "static/media/robinhood-wordmark.57543e0a.svg";